/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Force_AbandonInputs */



/**
* | output |
* | --- |
* | "Force Abandon" |
*
* @param {Vekn_Force_AbandonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_force_abandon = /** @type {((inputs?: Vekn_Force_AbandonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Force_AbandonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer l'abandon")
	if (locale === "es") return /** @type {LocalizedString} */ ("Forzar abandono")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Forçar Abandono")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forza Abbandono")
	return /** @type {LocalizedString} */ ("Force Abandon")
});